// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const GoalsTaskSelectionPanelContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-goalstaskselectionpanelcontainer" */ "./GoalsTaskSelectionPanelContainer")).then((bundle)=>{
        return {
            default: bundle.GoalsTaskSelectionPanelContainer
        };
    });
export const LazyGoalsTaskSelectionPanelContainer = /*#__PURE__*/ lazy(GoalsTaskSelectionPanelContainerLazyLoader);
